import React from 'react';
import { createRoot } from "react-dom/client"
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import App from './App';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Provider } from 'react-redux';
import Store from './store';
import { env } from './services/CommonFunction';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// require("react-datepicker/dist/react-datepicker-cssmodules.css");
// import "react-datepicker/dist/react-datepicker.css";
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(env('stripeKey'));

const container = document.getElementById("root")
const root = createRoot(container)

const app = (
    <BrowserRouter getUserConfirmation={(message, callback) => {
        // this is the default behavior
        const allowTransition = window.confirm(message);
        callback(allowTransition);
    }}>
        <Elements stripe={stripePromise}>
            <Provider store={Store}>
                <App />
            </Provider>
        </Elements>
    </BrowserRouter>
);
root.render(app);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);

